/** Use only with Antd Form */
/** Currently validator will no longer working if using regex from outside 'validator' object */

const validator = {
  validateCharactersCannotExceed: (rule, value) => {
    if (value && value.length > 255) {
      return Promise.reject('Ký tự không được vượt quá 255!')
    } else {
      return Promise.resolve()
    }
  },
}

export default validator
